import { environment } from '@/environments/environment'
export default [
  { name: 'getComplementaryProducts', url: 'http://localhost:8000/complementary_products/v1/complementary_products', method: 'get' },
  { name: 'requestComplementaryProduct', url: 'http://localhost:8000/complementary_products_request/v1/complementary_products_request', method: 'post'/* , headers: {'x-http-response': '400'}  */},
  { name: 'activeComplementaryProduct', url: 'http://localhost:8000/complementary_products_active/v1/complementary_products_active', method: 'post' }
]